// Individual exports for testing
import {call, put, takeLatest} from "redux-saga/effects";
import {AuthorizedRequestBuilder} from "../../utils/sagaBuilder";
import * as CONSTANTS from "./constants";
import moment from "moment";
import {authorizedRequest, HTTP_METHODS} from "../../utils/request";
import {generic} from "../../utils/action";

export const checkAvailabilitySaga = new AuthorizedRequestBuilder(
  CONSTANTS.GET_TIMESLOTS_SUCCESS,
  CONSTANTS.GET_TIMESLOTS_FAILED,
)
  .method(HTTP_METHODS.POST)
  .url(CONSTANTS.CHECK_AVAILABILITY_URL)
  .callbackBuilder((action, result) => () => {
    action.callback(result);
  })
  .body(({ date, duration, kptOverride, withScanner }) => ({
    data: {
      activity: {
        earliest_delivery_date: moment(date).format("DD-MM-YYYY"),
        duration: duration * 60,
        tag_names: ["blok"],
        allowed_driver_ids: kptOverride ? [kptOverride] : [],
      },
    },
    withScanner: withScanner || false
  }))
  .build();


export function* getTimeslotDriversSaga() {
  try {
    const drivers = yield call(authorizedRequest, "/drivers");

    yield put(
      generic(CONSTANTS.GET_TIMESLOT_DRIVERS_SUCCESS, {
        drivers,
      }),
    );
  } catch (e) {
    yield put(
      generic(CONSTANTS.GET_TIMESLOT_DRIVERS_FAILED, {
        reason: e.response.data,
      }),
    );
  }
}

export function* getAvailabilityScanners({date}) {
  const body = {
    date: moment(date).format("DD-MM-YYYY"),
  };
  try {
    const scanners = yield call(authorizedRequest, "/scanners",{
      method: "post",
      body,
    });

    yield put(
      generic(CONSTANTS.GET_AVAILABILITY_SCANNERS_SUCCESS, {
        scanners,
      }),
    );
  } catch (e) {
    yield put(
      generic(CONSTANTS.GET_AVAILABILITY_SCANNERS_FAILED, {
        reason: e.response.data,
      }),
    );
  }
}

export default function* timeSpanPlannerPageSaga() {
  // takeLatest will cancel previous task.
  yield takeLatest(CONSTANTS.GET_TIMESLOTS, checkAvailabilitySaga);
  yield takeLatest(CONSTANTS.GET_TIMESLOT_DRIVERS, getTimeslotDriversSaga);
  yield takeLatest(CONSTANTS.GET_AVAILABILITY_SCANNERS, getAvailabilityScanners)
}
